import { Link } from 'react-router-dom';
import Icon from './Icon';
import { IMG, u } from '../images';

const BG = [
  'from-brand to-ink',
  'from-ink-3 to-brand',
  'from-brand-dark to-brand-soft',
  'from-ink to-brand-dark',
  'from-brand to-brand-soft',
  'from-ink-2 to-brand',
];

// Abstract UI mockups drawn with CSS so no stock imagery is needed.
export function Mockup({ kind }) {
  const bar = 'rounded-full bg-white/70';
  if (kind === 'phone') {
    return (
      <div className="relative mx-auto h-44 w-24 rounded-[1.4rem] border-[3px] border-white/80 bg-ink/60 p-2 shadow-2xl backdrop-blur">
        <div className="mx-auto h-1 w-8 rounded-full bg-white/60" />
        <div className="mt-3 h-14 rounded-lg bg-brand-lime/80" />
        <div className={`${bar} mt-2 h-1.5 w-4/5`} /><div className={`${bar} mt-1.5 h-1.5 w-3/5 opacity-60`} />
        <div className="mt-3 grid grid-cols-2 gap-1.5"><div className="h-9 rounded-md bg-white/25" /><div className="h-9 rounded-md bg-white/25" /></div>
      </div>
    );
  }
  if (kind === 'store') {
    return (
      <div className="mx-auto w-48 rounded-xl border border-white/30 bg-white/90 p-3 shadow-2xl">
        <div className="flex gap-1.5"><i className="h-1.5 w-1.5 rounded-full bg-brand" /><i className="h-1.5 w-1.5 rounded-full bg-brand-lime" /></div>
        <div className="mt-2 grid grid-cols-3 gap-1.5">
          {[0, 1, 2, 3, 4, 5].map((i) => <div key={i} className={`h-10 rounded-md ${i % 2 ? 'bg-brand-lime/60' : 'bg-brand/70'}`} />)}
        </div>
        <div className="mt-2 h-5 rounded-md bg-ink" />
      </div>
    );
  }
  if (kind === 'brand') {
    return (
      <div className="flex items-center justify-center gap-3">
        <div className="grid h-24 w-24 place-items-center rounded-3xl bg-white shadow-2xl"><img src="/logo-mark.png" alt="" className="h-12 w-auto" /></div>
        <div className="space-y-2"><i className="block h-8 w-14 rounded-xl bg-brand-lime" /><i className="block h-8 w-14 rounded-xl bg-white" /><i className="block h-8 w-14 rounded-xl bg-ink" /></div>
      </div>
    );
  }
  if (kind === 'motion') {
    return (
      <div className="relative mx-auto grid h-32 w-48 place-items-center rounded-xl border border-white/30 bg-ink/50 shadow-2xl backdrop-blur">
        <span className="grid h-14 w-14 place-items-center rounded-full bg-brand-lime text-ink"><Icon name="animation" className="h-7 w-7" /></span>
        <div className="absolute inset-x-3 bottom-3 h-1.5 rounded-full bg-white/20"><div className="h-full w-2/3 rounded-full bg-brand-lime" /></div>
      </div>
    );
  }
  return (
    <div className="mx-auto w-52 rounded-xl border border-white/30 bg-white/95 p-3 shadow-2xl">
      <div className="flex h-20 items-end gap-1.5">
        {[40, 65, 50, 85, 60, 95].map((h, i) => <div key={i} className="flex-1 rounded-t-md bg-gradient-to-t from-brand to-brand-lime" style={{ height: `${h}%` }} />)}
      </div>
      <div className="mt-2 flex gap-1.5"><div className="h-2 flex-1 rounded bg-brand/20" /><div className="h-2 w-8 rounded bg-brand-lime" /></div>
    </div>
  );
}

export function ProjectVisual({ project, index = 0, className = 'h-60' }) {
  return (
    <div className={`relative grid place-items-center overflow-hidden bg-gradient-to-br ${BG[index % BG.length]} ${className}`}>
      <img src={u(IMG.project[project.slug], 1400)} alt={project.name} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-ink/60 via-transparent to-brand/10" />
    </div>
  );
}

export default function ProjectCard({ project, index }) {
  return (
    <Link to={`/portfolio/${project.slug}`} className="group block overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-brand/10 transition-shadow duration-300 hover:shadow-2xl">
      <div className={`relative grid h-60 place-items-center overflow-hidden bg-gradient-to-br ${BG[index % BG.length]}`}>
        <img src={u(IMG.project[project.slug], 900)} alt={project.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-brand/10" />
        <span className="absolute bottom-4 right-4 grid h-11 w-11 translate-y-2 place-items-center rounded-full bg-brand-lime text-ink opacity-0 shadow-lg transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"><Icon name="arrow" className="h-5 w-5" /></span>
        <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-brand">{project.cat}</span>
      </div>
      <div className="p-6">
        <p className="text-xs font-semibold uppercase tracking-wider text-brand">{project.tag}</p>
        <h3 className="mt-1 text-xl font-bold text-ink">{project.name}</h3>
        <p className="mt-2 text-[15px] leading-relaxed text-slate-600">{project.desc}</p>
        <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-brand">
          View case study <Icon name="arrow" className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
